import React from 'react';
import PropTypes from 'prop-types';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { frFR } from '@mui/x-date-pickers/locales';
import 'dayjs/locale/fr.js';

/**
 * Reusable Date Range Filter Component
 * Used in Devis.js and Factures.js
 */
const datePickerSx = {
  "& .MuiInputLabel-root": { color: '#797979' },
  "& fieldset": { border: '1px solid #eee' },
};

export default function DateRangeFilter({ 
  startDate, 
  endDate, 
  onStartDateChange, 
  onEndDateChange,
  startLabel = 'Du',
  endLabel = 'au',
}) {
  return (
    <>
      <div className="flex items-center gap-x-4">
        <h3 className="text-lg font-normal text-primary">{startLabel}</h3>
        <LocalizationProvider 
          dateAdapter={AdapterDayjs} 
          adapterLocale="fr" 
          localeText={frFR.components.MuiLocalizationProvider.defaultProps.localeText}
        >
          <DatePicker 
            value={startDate}
            onChange={onStartDateChange}
            sx={datePickerSx}
            slotProps={{ textField: { size: 'small' } }} 
          />
        </LocalizationProvider>
      </div>
      <div className="flex items-center gap-4">
        <h3 className="text-lg font-normal text-primary">{endLabel}</h3>
        <LocalizationProvider 
          dateAdapter={AdapterDayjs} 
          adapterLocale="fr" 
          localeText={frFR.components.MuiLocalizationProvider.defaultProps.localeText}
        >
          <DatePicker 
            value={endDate}
            onChange={onEndDateChange}
            sx={datePickerSx}
            slotProps={{ textField: { size: 'small' } }} 
          />
        </LocalizationProvider>
      </div>
    </>
  );
}

DateRangeFilter.propTypes = {
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  onStartDateChange: PropTypes.func,
  onEndDateChange: PropTypes.func,
  startLabel: PropTypes.string,
  endLabel: PropTypes.string,
};
